var AppDecorate = require('../../../../app/decorate');

module.exports = AppDecorate(require('./app/director'), Backbone.View.extend({
  views: {},
  Views: {},
  uploadViewKey: '',
  buttons: [],
  template: require('./director.hbs'),

  events: {
    'click dt > a:not([data-key="add"])': 'listContentToggleEvent'
  },

  listContentToggleEvent: function (event) {
    var $button = $(event.currentTarget);
    var $container = $button.closest('dt');
    var isActive = $container.hasClass('active');

    if (isActive) {
      var hasOpenSubView = !$button.children('.back').is('.hidden');

      hasOpenSubView && this.closeSubView($button);
      hasOpenSubView || collapseList.call(this);
    } else uncollapseList.call(this);

    function collapseList () {
      var isAllClosed = this.hideListContent($button);
      isAllClosed && $container.removeClass('active');
    }

    function uncollapseList () {
      this.showListContent($button);
      $container.addClass('active');
    }
  },

  initialize: function () {
    _.bindAll(this,
      'show',
      'render',
      'hideListContent',
      'closeAccordion',
      'openSubView'
    );
  },

  render: function () {
    var html = this.template({
      class: this.class,
      buttons: this.buttons.filter(function (button) { return !button.disabled; })
    });

    this.$el.html(html);
    this.initializeUpload();
  },

  initializeUpload: function () {
    var view = this.loadListContent(this.uploadViewKey);
    var $button = this.$el.find('dt a[data-key="' + this.uploadViewKey + '"]');
    var $container = this.$el.find('dt a[data-key="add"]').parent();
    var debouncedOpenProjectTab = _.debounce(_.bind(openProjectTab, this), 600);

    $container.fineUploaderS3(view.getUploaderOptions($container))
      .on('progress', view.progressEvent)
      .on('error', view.errorEvent)
      .on('cancel', view.cancelEvent)
      .on('complete', view.completeEvent)
      .on('submitted', _.bind(function () {
        debouncedOpenProjectTab();
        view.submittedEvent.apply(view, arguments);
      }, this));

    this.beforeSubmitEvent && $container.on('click', this.beforeSubmitEvent);

    function openProjectTab () {
      this.showListContent($button);
      $button.parent().addClass('active');
    }
  },

  show: function () {
    var now = new Date();
    var isAlreadyThere = this.$el.find('.tab-content.' + this.class.split(' ').join('.')).length;
    var isDoubleClick = now - this.showingTime < 600;

    isAlreadyThere || this.render();
    isAlreadyThere && isDoubleClick && this.closeAccordion();
    this.showingTime = now;
  },

  closeAccordion: function () {
    _.each(this.views, function (view, key) {
      var $button = this.$el.find('dt a[data-key="' + key + '"]');
      var $container = $button.closest('dt');

      $container.removeClass('active');
      this.hideListContent($button, key);
    }, this);
  },

  loadListContent: function (key, $btn) {
    var $button = $btn || this.$el.find('dt a[data-key="' + key + '"]');
    this.views[key] = new this.Views[key]({ el: getNewImageListContainer() });
    this.views[key].on('open_new_view', _.partial(this.openSubView, $button));

    return this.views[key];

    function getNewImageListContainer () {
      var $container = $('<div></div>')
        .addClass('image-list content ' + key);

      $container.insertAfter($button);
      return $container;
    }
  },

  openSubView: function ($button, data) {
    $button.children('.collapse-accordion').addClass('hidden');
    $button.children('.back').removeClass('hidden');
  },

  closeSubView: function ($button) {
    var key = $button.data('key');
    var isLastSubview = this.views[key].closeView
      ? this.views[key].closeView()
      : true;

    if (isLastSubview) {
      $button.children('.collapse-accordion').removeClass('hidden');
      $button.children('.back').addClass('hidden');
    }
  },

  showListContent: function ($button, key) {
    key = typeof key !== 'undefined' ? key : $button.data('key');

    this.toggleAcordionElement($button, true);
    this.views[key]
      || this.loadListContent(key, $button);

    this.views[key]
      && this.views[key].refreshView
      && this.views[key].refreshView();
  },

  hideListContent: function ($button, key) {
    key = key || $button.data('key');

    this.toggleAcordionElement($button, false);
    if (!this.views[key].closeView) return true;
    while (!this.views[key].closeView()) {}
    return true;
  },

  toggleAcordionElement: function ($button, value) {
    var $container = $button.closest('dt');
    var $wrapper = $container.closest('.wrapper');

    $button.children('i').addClass('hidden', value);
    $button.children('.main').toggleClass('hidden', value);
    $button.children('.collapse-accordion').toggleClass('hidden', !value);

    var top = value ? '-' + $container.position().top + 'px' : 0;
    var height = value ? $container.closest('[role="tabpanel"]').height() : '';

    $wrapper.css('top', top);
    $container.height(height);
  }
}));
